import { Switch, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MailingSection.css';
import { IMailingToggle } from '../../../../types/mailingToggles';
import { GroupHeader } from '../GroupHeader';

interface IMailingSectionProps {
  toggles: IMailingToggle[];
  onToggleChange(id: string, value: boolean): void;
}

export function MailingSection({ toggles, onToggleChange }: IMailingSectionProps) {
  return (
    <div className={styles['container']}>
      <GroupHeader title="Сообщения" />
      <div className={styles['list']}>
        {toggles.map(toggle => (
          <div key={toggle.id} className={styles['item']}>
            <UIText1>{toggle.title}</UIText1>
            <Switch
              defaultChecked={toggle.isActive}
              onChange={(_, value) => onToggleChange(toggle.id, value)}
              data-name="Switch"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
